import React, { useEffect, useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';
import Heading from 'components/common/heading/heading';

export default function OrdersPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Orders, 'Orders');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Orders', selected: true }]);
  }, []);

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <div className='flex-grow-1 d-flex justify-content-end'>
            <Inputs.Button variant='primary' href='/Orders/Create' iconClass='icons8-plus-math' label='Create Order' />
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-md-10 col-lg-8 col-xl-6'>
            <Panel>
              <Panel.Header>Orders</Panel.Header>
              <Panel.Body>
                <ul className='list-group list-group-flush'>
                  <a className='list-group-item list-group-item-action' href='/Orders/5'>
                    Test
                  </a>
                  <a className='list-group-item list-group-item-action' href='/Orders/6'>
                    Test
                  </a>
                </ul>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}